<div class="sr-only" tabindex="-1" id="ariaEventStatus" aria-label=""></div>
<div  class="row abs-no-gutters" [ngClass]="{'mt-5': isB2B}">
    <div class="contentdiv col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 m-0" [ngClass]="{ 'd-flex flex-column': !smallScreen }">
        <!-- <app-breadcrumb [pageFlags]="pageFlags"></app-breadcrumb> -->
    
        <ng-container *ngIf="!smallScreen">
            <ng-container *ngIf="isB2B">
                <app-breadcrumb [pageFlags]="pageFlags"></app-breadcrumb>
                <app-left-navigation></app-left-navigation>
            </ng-container>
    
            <app-filters *ngIf="!isBonusPath" [filtersData]="filtersData"></app-filters>
    
            <div>
                <!-- side banner xf -->
                <ng-container *ngIf="!allDealsGAMBannersDisabled && !isB2B">
                    @defer (when showAds) {
                        <banner-unit-v1 [bannerPositionName]="'leftsideb1'"></banner-unit-v1>
                    }
                </ng-container>
            </div>
        </ng-container>
    </div>
    <div class="js-gridDataParse" #sortOptions>
        <input type="hidden" name="availableSorts" value="purchase-history, new-offers, about-to-expire">
        <input type="hidden" name="couponGridPage" value="search">
        <input type="hidden" name="couponHeaderType" value="departmentName">
        <input type="hidden" name="couponDefaultMessage" value="">
        <input type="hidden" name="couponDefaultSort" value="">
    </div>
    <div class="asidediv col-12 col-sm-12 col-md-12 col-lg-9 col-xl- m-0 p-0">
        <div class="title-bg clearfix" *ngIf="isB2B">
            <h1 role="heading" id="dealsPageTitle" aria-label="Deals+ page Title" aria-level="1"
                class="simple-page-title-text display-4" tabindex="0" data-qa="smpl-pg-ttl">
                Deals+
            </h1>
        </div>
        <div class="simple-page-title section">
    
            <!-- top banner xf -->
            <!-- <div [class.mt-3]="smallScreen" [ngClass]="showCarousel ? '' : 'banner-unit__injection--loading-animation'" style="height: 220px;">
                @defer (when showCarousel) {
                    <banner-unit-carousel-v1 [carouselSelector]="('.abs-carousel')"></banner-unit-carousel-v1>
                }
            </div> -->
            <ng-container *ngIf="isB2B && smallScreen">
                <app-breadcrumb [pageFlags]="pageFlags"></app-breadcrumb>
                <app-left-navigation></app-left-navigation>
            </ng-container>
            <div class="carousel-content-loading-short" [style.height]="!smallScreen ? '100vh' : null"
                 *ngIf="baseCoupons?.length <= 0 && !displayNoResults">
                <div class="loading-spinner loading-image">
                    <div class="large progress" alt="Loading...">
                        <div class="prog1">
                            <div class="prog2"></div>
                        </div>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="smallScreen && !isBonusPath">
                <div class="d-flex flex-row justify-content-between">
                    <div>
                        <app-filters class="isSmallScreen" [filtersData]="filtersData"></app-filters>
                    </div>
                    <div class="mt-3">
                        <app-sort [sortRules]='sortRules' [activeSortRule]='activeSortRule'
                            (activeSortRuleEmitter)='activeSortRuleEmitter($event)'>
                        </app-sort>
                    </div>
                </div>
            </ng-container>
            <!-- Autoclip Messages Component -->
            <!-- <app-autoclip-messages></app-autoclip-messages> -->
            <ng-container *ngIf="baseCoupons?.length > 0">
                <app-offer-card-grid [userInfo]="userInfo" [couponsList]="baseCoupons"
                    [displayNoResults]="displayNoResults" [couponGridType]="couponGridType"
                    [isBonusPath]="isBonusPath">
                </app-offer-card-grid>
            </ng-container>
        </div>
    </div>

</div>
<div class="container-fluid">
    <div class="row abs-no-gutters">
        <div class="remove-rl-padding col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <ng-container *ngIf="!allDealsGAMBannersDisabled && !isB2B">
            @defer (when showAds) {
                <banner-unit-v1 [bannerPositionName]="('bottomb1')"></banner-unit-v1>
            }
          </ng-container>
        </div>
    </div>
</div>